<template>
    <Head>
        <title>Тарифы</title>
    </Head>

    <authenticated-layout :notifications="notifications" >

        <template #header>
            <navigation v-if="userId" :user-id="userId"/>
            <organization-navigation v-if="organizationId" :organization-id="organizationId"/>
        </template>


        <div class="bg-white p-6">

            <div class="flex flex-row justify-between items-end pb-6">
                <h1 class="text-2xl">Тарифы</h1>

                <span
                    @click="add"
                    class="flex items-center text-green-400 hover:text-green-600 cursor-pointer gap-2"
                    v-if="user && accountId || !user"
                >
                    <svg
                        class="fill-current h-6 w-6"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 16 16"
                    >
                        <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                    </svg>
                    ADD
                </span>
            </div>

            <div v-if="tariffs">
                <div class="grid grid-cols-12 border-b text-sm items-end text-gray-700 font-semibold uppercase p-2 gap-4">
                    <span>priority</span>
                    <span class="col-span-2">action</span>
                    <span>Тип</span>
                    <span>amount</span>
                    <span>min amount</span>
                    <span>max amount</span>
                    <span class="col-span-2">comment</span>
                    <span class="text-center">created (UTC)</span>
                    <span class="text-center">updated (UTC)</span>
                </div>

                <form
                    v-if="tariffs"
                    v-for="t of tariffsSorted"
                    class="grid grid-cols-12 border-b p-2 gap-4 text-sm items-center"
                >
                    <v-input type="number" v-model="t.priority" :ref="`priority_${t.index}`"
                             @change="change(t.index, 'priority', t.priority)"/>

                    <div class="col-span-2" v-if="t.id === undefined">
                        <v-select v-model="t.action">
                            <option v-for="action of actions" :value="action">{{ action }}</option>
                        </v-select>
                    </div>
                    <span v-else class="col-span-2">{{ t.action }}</span>

                    <v-select v-if="t.id === undefined" v-model="t.type">
                        <option v-for="type of types" :value="type">{{ type }}</option>
                    </v-select>
                    <span v-else>{{ t.type }}</span>

                    <div class="flex flex-row gap-1">
                        <v-input type="number" step="0.01" v-model="t.amount" @change="change(t.index, 'amount', t.amount)"/>
                        <span v-if="t.type === 'PERCENT'">%</span>
                    </div>
                    <v-input type="number" step="0.01" v-model="t.minAmount" @change="change(t.index, 'minAmount', t.minAmount)"/>
                    <v-input type="number" step="0.01" v-model="t.maxAmount" @change="change(t.index, 'maxAmount', t.maxAmount)"/>
                    <v-input class="col-span-2" v-model="t.comment" @change="change(t.index, 'comment', t.comment)"/>
                    <span class="text-center">{{ moment(t.createdAt).utc().format('L LTS') }}</span>
                    <span class="text-center">{{ moment(t.updatedAt).utc().format('L LTS') }}</span>
                    <div class="flex justify-end gap-4">
                        <svg
                            @click="save(t.index)"
                            class="fill-current h-6 w-6"
                            :class="{
                                'cursor-not-allowed': !changed[t.index],
                                'text-gray-300': !changed[t.index],
                                'text-green-400': !!changed[t.index],
                                'hover:text-green-600': !!changed[t.index],
                                'cursor-pointer': !!changed[t.index],
                            }"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 16 16"
                        >
                            <path d="M8.5 1.5A1.5 1.5 0 0 1 10 0h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h6c-.314.418-.5.937-.5 1.5v7.793L4.854 6.646a.5.5 0 1 0-.708.708l3.5 3.5a.5.5 0 0 0 .708 0l3.5-3.5a.5.5 0 0 0-.708-.708L8.5 9.293V1.5z"/>
                        </svg>
                        <svg
                            @click="trash(t.index)"
                            class="fill-current h-6 w-6 text-red-400 hover:text-red-600 cursor-pointer"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 16 16"
                        >
                            <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
                        </svg>
                    </div>
                </form>

            </div>
        </div>

        <ModalConfirm
            :showing="removeId !== false"
            @close="removeId = false"
            @submit="remove"
        >
            Remove tariff?
        </ModalConfirm>

    </authenticated-layout>

</template>

<script>
import moment from "moment";
import {Head, Link} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import Navigation from '@/Components/Navigation/User';
import OrganizationNavigation from '@/Components/Navigation/Organization';
import VInput from "@/Components/Input";
import VButton from "@/Components/Button";
import VSelect from "@/Components/Select";
import ModalConfirm from "@/Components/ModalConfirm";

export default {
    components: {
        Head, Link,
        AuthenticatedLayout,
        Navigation, OrganizationNavigation,
        VInput,
        VButton,
        VSelect,
        ModalConfirm,
    },
    props: {
        notifications: Object,
        tariffs: Object,
        userId: String,
        organizationId: String,
        accountId: String,
        actions: Object,
        types: Object,
    },
    data () {
        return {
            changed: {},
            removeId: false,
        }
    },
    computed: {
        tariffsSorted() {
            const {tariffs} = this;
            return Object.values(tariffs)
                .map((e, i) => {
                    e.index = i;
                    return e;
                })
                .sort((a, b) => b.priority - a.priority);
        }
    },
    methods: {
        moment,
        trash(id) {
            const {tariffs} = this;

            if(tariffs[id].id === undefined)
                tariffs.splice(id, 1);
            else
                this.removeId = id;
        },
        remove() {
            const {tariffs} = this;

            const id = tariffs[this.removeId].id;
            axios.delete(this.route('ocp.tariff.delete', id))
                .then((res) => {
                    const {data} = res;
                    if(data.success)
                        tariffs.splice(this.removeId, 1);
                    else
                        this.$props.notifications = Object.assign(this.$props.notifications, data.notifications);
                    this.removeId = false;
                });
        },
        change(id, name, value) {
            const {tariffs, changed} = this;
            if(typeof changed[id] !== 'object')
                changed[id] = {
                    id: tariffs[id].id,
                }
            changed[id][name] = value;
        },
        save(id) {
            const {tariffs, changed} = this;
            if(!changed[id]) return false;

            const changeable = changed[id];
            changed[id] = false;

            if(tariffs[id].id !== undefined)
                axios.post(this.route('ocp.tariff.update', tariffs[id].id), changeable)
                    .then((res) => {
                        const {data} = res;
                        if(!data.success) {
                            this.$props.notifications = Object.assign(this.$props.notifications, data.notifications);
                            changed[id] = true;
                        }
                    });
            else
                axios.post(this.route('ocp.tariff.create'), tariffs[id])
                    .then((res) => {
                        const {data} = res;
                        if(data.success) {
                            tariffs[id].id = data.result;
                        } else {
                            this.$props.notifications = Object.assign(this.$props.notifications, data.notifications);
                            changed[id] = true;
                        }
                    })
        },
        add() {
            const tempId = this.tariffsSorted.length;
            this.tariffs[tempId] = {
                id: undefined,
                accountId: this.accountId,
                priority: this.tariffsSorted.length ? this.tariffsSorted[0].priority + 1 : 0,
                action: this.actions[Object.keys(this.actions)[0]],
                type: this.types[Object.keys(this.types)[0]],
                amount: 0.0,
                minAmount: null,
                maxAmount: null,
            };
            this.changed[tempId] = true;
        },
    },
}
</script>
